import toast from "react-hot-toast"
import { ConvertEnglish } from "../../components/ConterEnglsih"


export const collectorApiPost = (bodyInfo) =>{
    fetch(`https://amar-dish-server.vercel.app/collector`,{
        method:"POST",
        headers :{
            "content-type" : "application/json"
        },
        body : JSON.stringify(bodyInfo)
    })
    .then(res => res.json())
     .then(collectorData => {
        // console.log(collectorData)
        toast.success(<ConvertEnglish english={"Collector added successfully"} bangla={"কালেক্টর সংযোগ হয়েছে"} />)
    })
}

